import styled from 'styled-components';

import { WithThemeProps } from '../../styles';


type RootProps = {
	fullWidth: boolean;
};

const Root = styled.div<RootProps>`
	display: inline-flex;
	position: relative;
	font-family: 'Roboto', arial;

	${p => p.fullWidth && `
		width: 100%;
	`}
`;

const CalendarLayout = styled.div`
	position: relative;
	display: inline-block;
	font-family: 'Roboto', arial;
	background-color: #fff;
	padding: 16px 0;

	& .rdr-Day {
		transform: scale(1) !important;
	}

	${(p: WithThemeProps) => `

		& .rdr-Day.is-selected {
			background-color: ${p.theme.color.accentPrimaryPressed} !important;
		}

		& .rdr-Day:hover {
			background-color: ${p.theme.color.accentPrimaryHover} !important;
		}
	`}
`;

const createDatePickerTheme = () => {
	return {
		Calendar: {
			order: '2',
			width: '268px',
			padding: '0 15px 0 15px'
		},
		Day: {
			width: '34px',
			height: '34px',
			fontWeight: '400',
			fontSize: '12px',
			lineHeight: '1.25',
			backgroundColor: '#fff',
			display: 'inline-flex',
			flexFlow: 'row wrap',
			justifyContent: 'center',
			alignItems: 'center',
		},
		Weekday: {
			width: '34px',
			height: '34px',
			fontSize: '12px',
			fontWeight: '400',
			lineHeight: '1.25',
			marginBottom: '0',
			display: 'inline-flex',
			flexFlow: 'row wrap',
			justifyContent: 'center',
			alignItems: 'center',
		},
		DayHover: {
			color: '#fff'
		},
		DaySelected: {
			color: '#fff'
		},
		DayStartEdge: {},
		DayEndEdge: {},
		MonthAndYear: {
			fontSize: '14px',
			fontWeight: '500',
			lineHeight: '1.25',
		},
		MonthButton: {
			background: 'transparent',
			cursor: 'pointer'
		},
		MonthArrowPrev: {
			borderRightColor: 'rgba(0, 0, 0, 0.85)',
			position: 'relative',
			left: '-4px'
		},
		MonthArrowNext: {
			borderLeftColor: 'rgba(0, 0, 0, 0.85)',
			position: 'relative',
			right: '-4px'
		}
	};
};

export {
	Root,
	CalendarLayout,
	createDatePickerTheme,
};
